import { Box, Grid, List, Typography } from '@material-ui/core';
import { useDocumentStore } from '@roc/feature-documents';
import { Paper, PaperBorderType } from '@roc/ui';
import { observer } from 'mobx-react';
import { divider, listItem } from '../../payoffCalculator/subComponents/cardComponents/payoffCardListItem';

export const PaReconciliationLoanCard = observer(() => {
  const {
    documentStore: {
      documentFormStore: { paReconciliationStore },
    },
  } = useDocumentStore();
  const loanInfo = paReconciliationStore?.loanInfo;

  return (
    <Paper
      titleComponent={
        <Box display="flex" p={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h5">Loan</Typography>
            </Grid>
          </Grid>
        </Box>
      }
      borderType={PaperBorderType.SOLID_BORDER}
    >
      <Grid container style={{ padding: '0px 16px 16px' }} spacing={2}>
        <Grid item xs={6}>
          <List style={{ padding: '0px' }}>
            {listItem('Loan ID', loanInfo?.loanId ?? '-')}
            {divider}
            {listItem('Loan Status', loanInfo?.loanStatus ?? '-')}
            {divider}
            {listItem('Deal Name', loanInfo?.dealName ?? '-')}
          </List>
        </Grid>
        <Grid item xs={6}>
          <List style={{ padding: '0px' }}>
            {listItem('Payoff Date', loanInfo?.payoffDate ?? '-')}
            {divider}
            {listItem('Records', paReconciliationStore?.recordCount ?? '-')}
            {divider}
          </List>
        </Grid>
      </Grid>
    </Paper>
  );
});
